import { Level } from '../../models/api/codegen/code';

export function buildVisibleRows(levels: Level[], expandedSports: Set<number>, selectedSportId?: number): Level[] {
    const result: Level[] = []

    for (const level of levels) {
        if (level.l === 'SPORT') {
            if (selectedSportId !== undefined) {
                if (selectedSportId === level.i) {
                    result.push(level)
                }
            } else {
                result.push(level)
            }
            continue
        }

        if (level.l === 'CATEGORY') {
            if (selectedSportId !== undefined) {
                if (selectedSportId === level.si && !expandedSports.has(level.si)) {
                    result.push(level)
                }
            } else if (!expandedSports.has(level.si)) {
                result.push(level)
            }
            continue
        }

        if (level.l === 'FIXTURE') {
            if (selectedSportId !== undefined) {
                if (selectedSportId === level.si && !expandedSports.has(level.si)) {
                    result.push(level)
                }
            } else if (!expandedSports.has(level.si)) {
                result.push(level)
            }
        }
    }

    return result
}